(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[197],{

/***/ 6141:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(59622);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 29295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_stores__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33739);
/* harmony import */ var _utils_stores__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_utils_stores__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_ui_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96872);
/* harmony import */ var _components_ui_text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49732);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68856);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_icons_io5__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60155);







var ErrorInformation = function() {
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)("common").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex items-center justify-center border-t border-b border-gray-300 px-16 py-16 text-center sm:py-20 lg:py-24 xl:py-32",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                    src: _utils_stores__WEBPACK_IMPORTED_MODULE_1__.basePath + "/assets/images/404.svg",
                    alt: t("error-heading"),
                    width: 822,
                    height: 492
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    variant: "mediumHeading",
                    children: t("error-heading")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "pt-2 pb-7 text-sm leading-7 md:pt-3.5 md:pb-9 md:text-base",
                    children: t("error-sub-heading")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    href: "/",
                    className: "inline-flex cursor-pointer items-center rounded-lg bg-heading px-4 py-2.5 text-[13px] leading-4 text-white transition duration-300 ease-in-out hover:bg-gray-600 hover:text-white hover:shadow-cart md:px-6 md:text-sm lg:py-3 lg:text-base",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_6__/* .IoHomeSharp */ .KkC, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "ps-1.5",
                            children: t("button-go-home")
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ErrorInformation);


/***/ }),

/***/ 49732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);





var Text = function(param) {
    var style = param.style, className = param.className, _variant = param.variant, variant = _variant === void 0 ? "body" : _variant, children = param.children, html = param.html;
    var componentsMap = {
        body: "p",
        mediumHeading: "h3",
        heading: "h4",
        pageHeading: "h1",
        subHeading: "h2"
    };
    var Component = componentsMap[variant];
    var htmlContentProps = html ? {
        dangerouslySetInnerHTML: {
            __html: html
        }
    } : {};
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()({
            "text-sm leading-7 sm:leading-6": variant === "body",
            "text-body": variant === "body",
            "text-lg font-bold md:text-xl lg:text-2xl xl:leading-10 2xl:text-3xl": variant === "mediumHeading",
            "text-heading": variant === "mediumHeading" || variant === "heading" || variant === "pageHeading" || variant === "subHeading",
            "text-sm font-semibold md:text-base xl:text-lg": variant === "heading",
            "text-2xl font-bold": variant === "pageHeading",
            "text-lg font-bold md:text-2xl xl:text-3xl  2xl:text-4xl": variant === "subHeading"
        }, className),
        style: style
    }, htmlContentProps), {
        children: children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Text);


/***/ }),

/***/ 59622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ ErrorPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_404_error_information__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29295);
/* harmony import */ var _components_pagebuilder_pageBuilder__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96888);



var __N_SSG = true;
function ErrorPage(props) {
    var ref;
    var cmsPage = props.cmsPage;
    if (!(cmsPage === null || cmsPage === void 0 ? void 0 : (ref = cmsPage.pagebuilder) === null || ref === void 0 ? void 0 : ref.html)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_404_error_information__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pagebuilder_pageBuilder__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        pagebuilder: cmsPage === null || cmsPage === void 0 ? void 0 : cmsPage.pagebuilder
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [675,928,888,179], function() { return __webpack_exec__(6141); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);